import React, { useRef } from 'react';

import { useTrustPilotWidgetLoader } from 'Utilities/hooks/useTrustPilotWidgetLoader';

import { Content } from 'LegacySBCRA/Content/Content';
import { LoadingArrow } from 'Storybook/components/local/LoadingArrow/LoadingArrow';

import styles from './ReviewsList.scss';

interface TrustPilotReviewsListHtmlProps {
  failedLoad?: boolean | null;
  ref?: React.RefObject<HTMLDivElement | null>;
}

interface ReviewsListProps extends TrustPilotReviewsListHtmlProps {
  setFailedLoad?: (failed?: boolean) => void;
}

const TrustPilotReviewsListHtml = React.memo(
  (
    {
      failedLoad = null,
      ref,
    }: TrustPilotReviewsListHtmlProps,
  ) => {
    if (failedLoad) {
      return null;
    }

    return (
      <Content className={styles.component}>
        <div
          ref={ref}
          className="trustpilot-widget"
          data-businessunit-id="59f1a7fc0000ff0005aeb29e"
          data-locale="en-GB"
          data-style-height="1800px"
          data-style-width="100%"
          data-template-id="539ad60defb9600b94d7df2c"
          data-theme="light"
          id="trustpilot-widget-list"
        >
          <LoadingArrow data-thc-loading-indicator />
        </div>
      </Content>
    );
  },
  ({ failedLoad: previousValue }, { failedLoad: newValue }) => previousValue === newValue,
);

export const ReviewsList: React.FC<ReviewsListProps> = ({ failedLoad, setFailedLoad }) => {
  const $container = useRef<HTMLDivElement>(null);

  const observerSettings = {
    disconnectOnVisible: true,
    rootMargin: '500px',
    threshold: 0,
  };

  useTrustPilotWidgetLoader({ $container, observerSettings, setFailedLoad, suppressWidget: false });

  return <TrustPilotReviewsListHtml ref={$container} failedLoad={failedLoad} />;
};
